<template>
    <div class="general-wrapper-contact">
        <h1 class="header-title">Contact</h1>
          <v-divider></v-divider>
          <div class="header-title-form">Suggestion Box</div>
            <notification-container
              :status="status"
            />
              <b-alert variant="success" show>          
                Do you have a suggestion or an idea for submission? If so, please enter your information and suggestion/recommendation below.
              </b-alert>

                 <form name="contact" method="POST" data-netlify="true" data-netlify-honeypot="bot-field" @submit.prevent="handleSubmit">
                    <input type="hidden" name="form-name" value="contact" />
                    <p>
                      <label>Your Name: <input type="text" name="name" @input="ev => form.name = ev.target.value" required/></label>   
                    </p>
                    <p>
                      <label>Your Email: <input type="email" name="email" @input="ev => form.email = ev.target.value" required/></label>
                    </p>
                    <p>
                      <label>Message: <textarea name="message" @input="ev => form.message = ev.target.value" required></textarea></label>
                    </p>
                    <p>
                      <button type="submit">Send</button>
                    </p>
            </form>
    </div>
</template>

<script src="https://cdn.jsdelivr.net/lodash/4.13.1/lodash.js"></script>

<script>
import NotificationContainer from "./NotificationContainer.vue";
import {analytics} from "../firebase";
analytics.logEvent("Advocacy");

export default {
  name: "contact",
  components: {
    NotificationContainer
  },
  data() {
    return {
      form: {
        email: "",
        name: "",
        message: ""
      },
      sent: false,
      status: {}
    };
  },
  methods: {
   
    removeNotification() {
      this.sent = false;
    },
    encode(data) {
      return Object.keys(data)
        .map(
          key => `${encodeURIComponent(key)}=${encodeURIComponent(data[key])}`
        )
        .join("&");
    },
    handleSubmit(e) {
      fetch("/", {
        method: "POST",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        body: this.encode({
          "form-name": "contact",
          ...this.form
        })
      })
        .then(() => {
          this.$router.push("thanks");
        })
        .catch(() => {
          this.$router.push("404");
        });
    }
  },
  mounted() {
                this.$ga.page('/contact');
            }
};
</script>

<style scoped>

form {
  background: rgb(248, 248, 248);
  padding: 3em;
  background: #fff;
  color: rgba(14, 30, 37, 0.54);
  border-radius: 8px;
  -webkit-box-shadow: 0 1px 6px 0 rgba(14, 30, 37, 0.12);
  box-shadow: 0 1px 6px 0 rgba(14, 30, 37, 0.12);
}
label {
  color: #05668d;
  font-weight: bold;
}

input[type="text"], input[type="email"],
textarea {
  box-sizing: border-box;
  display: block;
  width: 100%;
  height: 40px;
  margin: 0;
  padding: 6px 14px;
  border: 2px solid #e9ebeb;
  border-radius: 4px;
  background: 0 0;
  color: #0e1e25;
  -webkit-box-shadow: none;
  box-shadow: none;
  font-size: 16px;
  font-weight: 500;
  line-height: 24px;
}
textarea {
  height: 200px;
}
span {
  margin-left: 15px;
  vertical-align: top;
}

.header-title-form{
  text-align: center;
  width: 45vw;
  font-size: 1.5em;
        font-weight: bold;
        color: #05668d;
}

.alert-success{
  width: 45vw;
}

.title-form{
  text-align: left;
  font-weight: bold;
  
}

.general-wrapper-contact{
        width: 75vw;
        padding-left:30vw;
        padding-right:10px;
        
  }

  @media screen and (max-width: 900px){
            .general-wrapper-contact {
              width: 100vw;
              max-width: 400px;
              padding-left:10px;
              padding-right:10px;
        }

        .alert-success{
          width: 95vw;
      }

      .header-title-form{
        text-align: center;
        width: 100vw;
        font-size: 1.5em;
        font-weight: bold;
        color: #05668d;
        margin-right:5px
      }
  }

  
</style>

